var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangleWarning600(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 8.00021V12.0002M11.9998 16.0002H12.0098M10.2898 2.8602L1.81978 17.0002C1.64514 17.3026 1.55274 17.6455 1.55177 17.9947C1.55079 18.3439 1.64127 18.6873 1.8142 18.9907C1.98714 19.2941 2.2365 19.547 2.53748 19.7241C2.83847 19.9012 3.18058 19.9964 3.52978 20.0002H20.4698C20.819 19.9964 21.1611 19.9012 21.4621 19.7241C21.7631 19.547 22.0124 19.2941 22.1854 18.9907C22.3583 18.6873 22.4488 18.3439 22.4478 17.9947C22.4468 17.6455 22.3544 17.3026 22.1798 17.0002L13.7098 2.8602C13.5315 2.56631 13.2805 2.32332 12.981 2.15469C12.6814 1.98605 12.3435 1.89746 11.9998 1.89746C11.656 1.89746 11.3181 1.98605 11.0186 2.15469C10.7191 2.32332 10.468 2.56631 10.2898 2.8602Z",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangleWarning600);
export default __webpack_public_path__ + "static/media/alert-triangle-warning600.f5b167425069980e2fa486a4937d84db.svg";
export { ForwardRef as ReactComponent };